module.exports = __webpack_public_path__ + "static/media/11.76e2b7a9.mp4";